import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

//utils
import queries from '../../../utils/queries'

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// import SeguroPermite from '../../../components/funcionales/seguropermite'

import EstaSeguro from '../../../components/funcionales/estaseguro'
import general from '../../../modulos/general';

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

// "use strict";

//Lista de candidatos a DX
const FactCli = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.estadoDetDX}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className=''>{elemento.descrClaseServM}</td>
      <td className=''>{elemento.descripcionServicioM}</td>
      <td className=''>{elemento.documento}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorTotal.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.valorPagado.toString())}</td>
      <td className=''>{elemento.pagueHasta.substr(0, 10)}</td>
      <td className=''>{elemento.diasMora}</td>
      <td className=''>{elemento.numVecesDX}</td>
    </tr>
  )
};

const ListaDX = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <FactCli elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// let fechaHoy = new Date()
// fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

// let agnoFra = fechaHoy.substr(0, 4)
// let mesFra = fechaHoy.substr(5, 2)
// let agnoFra = "2017"
// let mesFra = "03"

// const argsBuscarCL = {estadoCliente: "ACTIVO", numDocum: 2027}
// const argsBuscarCL = {estadoCliente: "ACTIVO", numDocum: 1}
// const argsBuscarCL = {numDocum: 1}
// const argsBuscarCL = {contrato: "XYZ321"}

// const argsBuscarMC = {agno: agnoFra, mes: mesFra}

class VerCliDX2 extends React.Component {
  state={confirmaAct: false, open: false, errors: []}
        
  handleChange = (ev) => {
    if(ev.target.name==="sololectura"){

    }
  }

  handleSubmit = async (ev, creaDetDX)=>{
//ACTUALIZAR BD
    async function crudBD(operacionCRUD, args, i) {
  // console.log("CRUD")
      if(args.ctrlCampo === 'CRUD'){
// console.log(i)
// console.log(args)
        const {data} = await operacionCRUD({
          variables: args
        });
  
  //Se utiliza para traer el _id del documento creado
        if(args.ctrl_id === 'SI_ID'){
          if(Object.values(data)[0]._id){
            return Object.values(data)[0]._id
          }else{
            return 0
          }
        }
      }else{
        if(args.ctrlCampo === "MANY"){
          // console.log("MANY")
          // console.log(args)
          await operacionCRUD({
            variables: args
          });
        }
      }
    }
  
  //ENVIO PARA ACTUALIZAR BD
    async function updColecc(crudColecc, argsCrud, totDocCRUD) {
// console.log(argsCrud)
// console.log(totDocCRUD)
      let codigo = 0
      // console.log(argsCrud)
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
// console.log("inicio")
      for(let i=1; i<totDocCRUD; i++){
        await crudBD(crudColecc[i], argsCrud[i], i)
      }
console.log("final")
    }

    let errors = []
    if(!this.props.allClientes.allClientes||!this.props.allMovClientes.allMovClientes||!this.props.allMovClientesCC.allMovClientesCC){
      errors.push({path: "DX", message: "Proceso de cargue de la información, por favor espere un momento..."});
    }
    this.setState({errors})

    let actmovCli = [], actCli = [], actServCli = [], actdetDX = [], actCliSaldo = [], creaHC = []


//PROCESO CERRAR DX MASIVA
    if(this.props.permiteClose&&errors.length===0){
      let argsUpd = {}
      argsUpd = {
        "_id": this.props.idLista._id,
        "estadoProcDX": "CERRADA"
      }
      // console.log(argsUpd)
      await this.props.editProcDX({
        variables: argsUpd
      });

      this.props.allDetalleDX.refetch(this.props.argsBuscar)
    }
//FIN PROCESO CERRAR DX MASIVA
//PROCESO ELIMINAR SERVICIOS DX MASIVA
    if(this.props.permiteDelete&&errors.length===0){
//ELIMINAR de detalleDX
let errors = []
creaDetDX.forEach(async (elemento, _id) => {
  if(elemento.estadoDetDX==="DX"){
    errors.push({path: "Eliminar", message: "El contrato " + elemento.contrato + " Servicio " + elemento.descripcionServicio + " ya fue DX, no lo puede eliminar"});
  }
})
this.setState({errors})
if(errors.length===0){

  creaDetDX.forEach(async (elemento, _id) => {
        actServCli.push({_id: elemento._id})
      })

// console.log(actServCli)
      let actServCliMany = []
      actServCli.forEach((elementoDX, ii) => {
        actServCliMany.push(elementoDX)
      })
      let actServCliMany1 = []
      actServCliMany1.push({detalledx: actServCliMany})

      let numDocCRUD = 0
      let totDocCRUD = 1
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editMovClientesDXMany)
      }

      argsCrud[numDocCRUD] = actServCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.deleteDetalleDXMany

// console.log(argsCrud)
// console.log(totDocCRUD)
      await updColecc(crudColecc, argsCrud, totDocCRUD)

      this.props.allDetalleDX.refetch(this.props.argsBuscar)
    }
    }
//FIN PROCESO ELIMINAR SERVICIOS DX MASIVA
//PROCESO DX SERVICIOS DX MASIVA
    if(this.props.permiteUpdate&&errors.length===0){
      document.body.style.cursor = 'wait'

      // let fechaHoy = new Date()
      // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
      // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy, fechaHoraHoy} = response.data.fecha
      let fechaHoy = fechaFechaHoy

// console.log(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
      // console.log("11")
//traer el número de días del mes
      const numDM = getNumDiasMes(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
      const numDF = numDM - parseInt(fechaHoy.substr(8, 2), 10) + 1
      // console.log("22")
      let movCli = [], movCliRX = [], elemento3 = [], elemento3CC = []
      let contServDX = 0, contServCli = 0, cliAnt = "XXX", contrCli = "YYY", saldoCl = 0, saldoClCC = 0
      let actFechas = [], argsUpdDX = {}
      // console.log("33")
      let clientesDX = []
      // let argsBuscarCL = {estadoCliente: "ACTIVO", numDocum: 2027}
      // // console.log(this.props.allClientes.allClientes)
      // // console.log(argsBuscarCL)
      // if(this.props.allClientes.allClientes){
      //   let {data} = await this.props.allClientes.refetch(argsBuscarCL)
      //   clientesDX = await data.allClientes
      // }

      let contratos = ""
      for(let ii=0; ii<creaDetDX.length; ii++){
        if(ii<creaDetDX.length-1){
          contratos += "'" + creaDetDX[ii].contrato + "', "
        }else{
          contratos += "'" + creaDetDX[ii].contrato + "'"
        }
      }
// console.log(contratos)

        let argsBuscarCL = `'estadoCliente': 'ACTIVO', 'contrato': {$in: [${contratos}]}`
        // console.log(argsBuscarCL)
        argsBuscarCL = '{' + argsBuscarCL + '}'
        argsBuscarCL = {tipoqry: `[{$match: ${argsBuscarCL}}]`}
// console.log(argsBuscarCL)
        if(this.props.allClientesRtes.allClientesRtes){
          let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
          clientesDX = await data.allClientesRtes
        }


// console.log(clientesDX)
// console.log(this.props.allClientes.allClientes)
      let agnoFra = fechaHoy.substr(0, 4)
      let mesFra = fechaHoy.substr(5, 2)
      // console.log("44")
      let movimDX = []
      // let movimDXCC = []
      let argsBuscarMC = {agno: agnoFra, mes: mesFra}
// console.log(argsBuscarMC)
      if(this.props.allMovClientes.allMovClientes){
        let {data} = await this.props.allMovClientes.refetch(argsBuscarMC)
        movimDX = await data.allMovClientes
      }
      // console.log("55")
      if(this.props.allMovClientesCC.allMovClientesCC){
        await this.props.allMovClientesCC.refetch(argsBuscarMC)
        // let {data} = await this.props.allMovClientesCC.refetch(argsBuscarMC)
        // movimDXCC = await data.allMovClientesCC
      }

// console.log(movimDX)
// console.log(this.props.allMovClientes.allMovClientes)
      creaDetDX.forEach(async (elemento, _id) => {
      // for(let ii=0; ii<creaDetDX.length; ii++){
      //   let elemento = creaDetDX[ii]
        // console.log(elemento)
        let listServTarAct = [], listServOfAct = [], actCargoFra = []
        let indexCargoDX = -1
        if(elemento.estadoDetDX==="GE"){
          // indexCargoDX = this.props.allClientes.allClientes.findIndex(cliente => cliente.contrato === elemento.contrato );

          // clientesDX = []
          // // argsBuscarCL = {contrato: elemento.contrato, estadoCliente: "ACTIVO", numDocum: 2027}
          // argsBuscarCL = {contrato: elemento.contrato}
          // // console.log(this.props.allClientes.allClientes)
          // console.log(ii, argsBuscarCL)
          // // if(this.props.allClientes.allClientes){
          // if(argsBuscarCL){
          //   let {data} = await this.props.allClientes.refetch(argsBuscarCL)
          //   console.log("antes de clientesDX")
          //   clientesDX = await data.allClientes
          //   console.log(clientesDX.length)
          // }
          // console.log(clientesDX)
          // indexCargoDX = clientesDX.findIndex(cliente => cliente.contrato === elemento.contrato
          //   && cliente.estadoCliente === "ACTIVO" );

          // console.log("288", elemento.contrato)
          indexCargoDX = clientesDX.findIndex(cliente => cliente.contrato === elemento.contrato );
          if(indexCargoDX !== -1){
            elemento3 = clientesDX[indexCargoDX].tarifa
            contrCli = clientesDX[indexCargoDX].contrato
            elemento3.servicios.forEach((elemento1, i) => {
              if(elemento1.codigoServicio===elemento.codigoServicio&&elemento1.estadoServicio==="D"){
                indexCargoDX = -1
              }
            })
          }
        }
        if(indexCargoDX !== -1){
          if(contrCli!==cliAnt){
            cliAnt = clientesDX[indexCargoDX].contrato
            contServDX = 1
            saldoCl = clientesDX[indexCargoDX].saldoPendiente
            // console.log(this.props.comoAsigCargosAlCliente)
            // console.log(saldoCl)
            saldoClCC = saldoCl
      
            contServCli = 0
            elemento3.servicios.forEach((elemento1, i) => {
              if(elemento1.estadoServicio!=="D"){
                contServCli += 1
              }
            })
// console.log(fechaHoy)
//OJOOOOOO falta actualizar fechaUltDX si se dx el cliente => incluir EditarFechCli  en upd MANY
//y al pagar y RX falta actualizar fecgaUltRX
            argsUpdDX = {
              "tipoAct": "EditarFechCli",
              "_id": clientesDX[indexCargoDX]._id,
              "fechaUltOSAb": clientesDX[indexCargoDX].fechaUltOSAb,
              "fechaPrimeraActivacion": clientesDX[indexCargoDX].fechaPrimeraActivacion,
              "fechaUltDX": fechaHoy,
              "fecgaUltRX": clientesDX[indexCargoDX].fecgaUltRX,
              "estadoAnterior": clientesDX[indexCargoDX].estadoAnterior,
              "fechaUltOSCe": clientesDX[indexCargoDX].fechaUltOSCe,
              "fechaUltPago": clientesDX[indexCargoDX].fechaUltPago,
              "valorUltPago": clientesDX[indexCargoDX].valorUltPago,
            }
          }else{
            contServDX += 1
          }
// console.log(contServCli)
// console.log(contServDX)
          let argsUpd = {}
          argsUpd['tipoAct'] = "EditarServDX"
          argsUpd['contrato'] = elemento.contrato
          argsUpd['tarifa'] = { codigoTarifa: elemento.codigoTarifa, servicios: 
                            [{"codigoServicio": elemento.codigoServicio,
                              "estadoServicio": "D"}]}
          actServCli.push(argsUpd)
//PROCESO CREAR DOCUM EN MOVIMCLIENTE DE DESCUENTO (SI YA SE FACT) O CARGUE (SI NO SE HA FACT) POR DX
          if(clientesDX[indexCargoDX].tarifa.codigoTarifa){
            // let elemento3 = this.props.allClientes.allClientes[indexCargoDX].tarifa

            elemento3.servicios.forEach((elemento1, i) => {
              if(elemento1.codigoServicio === elemento.codigoServicio){
                listServTarAct.push({codigoTarifa: elemento3.codigoTarifa, descrTarifa: elemento3.descrTarifa,
                  codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido, descripcionServicio: elemento1.descripcionServicio,
                  _idSubclaseServ: elemento1.subclaseserv._id, codigoSubclaseServ: elemento1.subclaseserv.codigoSubclaseServ,
                  descrSubclaseServ: elemento1.subclaseserv.descrSubclaseServ, _idClaseServ: elemento1.subclaseserv.claseserv._id,
                  codigoClaseServ: elemento1.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento1.subclaseserv.claseserv.descrClaseServ,
                  numeroServicios: elemento1.numeroServicios, valorServicios: elemento1.valorServicios, imptos: elemento1.imptos,
                  valorAntesImptos: elemento1.valorAntesImptos,
                  _id: i
                });
// console.log(listServTarAct)

//Si ya facturo el mes siguiente => descontar lo facturado
//OJOOOOO falta crear el mov si ya facturo el mes siguiente => tambien en recibir pago y RX

//FIN Si ya facturo el mes siguiente => descontar lo facturado
              }
            })
          }
          // console.log(clientesDX[indexCargoDX])
          // console.log(clientesDX[indexCargoDX].oferta)
          if(clientesDX[indexCargoDX].oferta&&clientesDX[indexCargoDX].oferta.codigoOferta){
            let elemento3 = clientesDX[indexCargoDX].oferta

            elemento3.servicios.forEach((elemento1, i) => {
              if(elemento1.codigoServicio === elemento.codigoServicio){
                let fechaInicial, fechaFinal
                !elemento1.fechaInicioOferta?fechaInicial = fechaHoy:fechaInicial = elemento1.fechaInicioOferta
                if(!elemento1.fechaFinOferta){
                  fechaFinal = new Date(elemento1.fechaInicioOferta?elemento1.fechaInicioOferta:fechaHoy)
                  fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(elemento1.numDiasOferta, 10))
                  fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
                }else{
                  fechaFinal = elemento1.fechaFinOferta
                }

                let fechaInicio = new Date(fechaInicial).getTime();
                let fechaFin    = new Date(fechaFinal).getTime();
                let numdiApliOf = parseInt((fechaFin - fechaInicio) / (1000*60*60*24), 10)
                if(numdiApliOf>numDF){
                  numdiApliOf = numDF
                }

                listServOfAct.push({codigoOferta: elemento3.codigoOferta, descrOferta: elemento3.descrOferta,
                  codigoServicio: elemento1.codigoServicio, nombreResumido: elemento1.nombreResumido, descripcionServicio: elemento1.descripcionServicio,
                  _idSubclaseServ: elemento1.subclaseserv._id, codigoSubclaseServ: elemento1.subclaseserv.codigoSubclaseServ,
                  descrSubclaseServ: elemento1.subclaseserv.descrSubclaseServ, _idClaseServ: elemento1.subclaseserv.claseserv._id,
                  codigoClaseServ: elemento1.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento1.subclaseserv.claseserv.descrClaseServ,
                  porcDctoOferta: elemento1.porcDctoOferta, numDiasOferta: elemento1.numDiasOferta,
                  numdiApliOf: numdiApliOf, _id: i
                });
              }
            })
          }

          // let agnoFra = fechaHoy.substr(0, 4)
          // let mesFra = fechaHoy.substr(5, 2)
          let numDNvo = 0

          let valorServ=0
          let valorAntesI = 0

          let periodoFrado
          let ddI = parseInt(fechaHoy.substr(8, 2), 10) - 1
          let diaFra= parseInt(fechaHoy.substr(8, 2), 10)

          elemento3 = this.props.allMovClientes.allMovClientes.filter(servicio => servicio.agno===agnoFra&&
            servicio.mes===mesFra&&servicio.contrato===elemento.contrato)

          elemento3CC = this.props.allMovClientesCC.allMovClientesCC.filter(servicio => servicio.agno===agnoFra&&
            servicio.mes===mesFra&&servicio.contrato===elemento.contrato)

          let difSaldoNeg = 0, valorPagNeg = 0
          //verificar si el valor total a descontar (neg) es mayor que el saldocl, si es asi, la dif se cruza con
          //los cargos positivos
          listServTarAct.forEach((elemento1, _id) => {
            // const indexFrado = elemento3.findIndex(servicio => servicio.codigoServicio === elemento1.codigoServicio);
            let indexFrado = elemento3.findIndex(servicio => servicio.codigoServicio === elemento1.codigoServicio);
            if(indexFrado===-1){
              indexFrado = elemento3CC.findIndex(servicio => servicio.codigoServicio === elemento1.codigoServicio);
            }
            if(indexFrado===-1){
              //se lo quitan y NO ha tenido movimientos en movclientes => a facturar los dias antes de dx
              numDNvo = ddI
              valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
            }else{
//se lo quitan y YA se lo habian facturado => descontarlo
              numDNvo = numDM - ddI
              valorServ = (Math.round((elemento1.valorServicios / numDM) * numDNvo)) * -1
            }
            
            if(valorServ<0){
              valorPagNeg += valorServ
            }
          })
          if(saldoCl<(valorPagNeg * -1)){
            difSaldoNeg = (valorPagNeg * -1) - saldoCl
          }
// console.log(listServTarAct, saldoCl, difSaldoNeg, valorPagNeg)
//SERVICIOS QUE SE QUITARON
          periodoFrado = ""
// console.log(listServTarAct)
// console.log(listServOfAct)
          listServTarAct.forEach((elemento1, _id) => {
            // const indexFrado = this.props.allMovClientes.allMovClientes.findIndex(servicio => servicio.codigoServicio === elemento1.codigoServicio
            //                           &&servicio.agno===agnoFra&&servicio.mes===mesFra&&
            //                           servicio.contrato===elemento.contrato);
            // const indexFrado = elemento3.findIndex(servicio => servicio.codigoServicio === elemento1.codigoServicio);
            let indexFrado = elemento3.findIndex(servicio => servicio.codigoServicio === elemento1.codigoServicio);
            if(indexFrado===-1){
              indexFrado = elemento3CC.findIndex(servicio => servicio.codigoServicio === elemento1.codigoServicio);
            }

                                      // console.log(indexFrado)
// console.log(this.props.allMovClientes.allMovClientes[indexFrado])
// console.log(elemento1)
            if(indexFrado===-1){
//se lo quitan y NO ha tenido movimientos en movclientes => a facturar los dias antes de dx
              numDNvo = ddI
              valorServ = Math.round((elemento1.valorServicios / numDM) * numDNvo)
              valorAntesI = Math.round((elemento1.valorAntesImptos / numDM) * numDNvo)

              periodoFrado = fechaHoy.substr(0, 8) + '01 a ' + (ddI<10?'0'+ddI:ddI)
            }else{
//se lo quitan y YA se lo habian facturado => descontarlo
              numDNvo = numDM - ddI
              valorServ = (Math.round((elemento1.valorServicios / numDM) * numDNvo)) * -1
              valorAntesI = (Math.round((elemento1.valorAntesImptos / numDM) * numDNvo)) * -1

              periodoFrado = fechaHoy.substr(0, 8) + (diaFra<10?'0'+diaFra:(diaFra))
              periodoFrado += ' a ' + fechaHoy.substr(0, 8) + numDM
            }



            let valorPag = 0
            if(difSaldoNeg>0&&valorServ>0){
              if(difSaldoNeg-valorServ>=0){
                valorPag = valorServ
              }else{
                valorPag = difSaldoNeg
              }
              difSaldoNeg -= valorPag
            }
    
            if(saldoCl<0&&valorServ>0){
              if(saldoCl+valorServ>0){
                valorPag = saldoCl * -1
              }else{
                valorPag = valorServ
              }
            }
            if(valorServ<0){
              valorPag = valorServ
            }   

            // console.log(elemento1, saldoCl, difSaldoNeg, valorPag, valorServ)





            let imptosServ = elemento1.imptos.map(impto => ({
              ...impto, valorImpto: Math.round(valorAntesI * impto.porcImpto / 100)}))
// console.log(elemento1)
// console.log(valorServ)
            if(valorServ!==0){
//CREA REGISTROS EN movclientes
              saldoCl += valorServ
              argsUpd = {}

              let movCliI = []
              argsUpd = {}
              imptosServ.forEach((elementoI, ii) => {
                if(elemento1.codigoImpto!==null){
                  argsUpd = {
                    "codigoImpto": elementoI.codigoImpto,
                    "descrImpto": elementoI.descrImpto,
                    "porcImpto": elementoI.porcImpto,
                    "valorImpto": elementoI.valorImpto,
                  }
                  movCliI.push(argsUpd)
                }
              })

              argsUpd = {}
              argsUpd = {
                "contrato": elemento.contrato,
                "fechaMov": fechaHoy,
                "tipo": "C",
                "subTipo": "DX",
                "procesado": "N",
                "codigoServicio": elemento1.codigoServicio,
                "nombreResumido": elemento1.nombreResumido,
                "descripcionServicio": elemento1.descripcionServicio,
                "descrClaseServ": elemento1.descrClaseServ,
                "periodo": periodoFrado,
                "origen": "DX-" + this.props.idLista.numeroOdeDX,
                "saldoCliente": saldoCl,
                "valorTotal": valorServ,
                "valorAntesImptos": valorAntesI,
                "agno": agnoFra,
                "mes": mesFra,
                "valorPagado": valorPag,
                "usuarioCreate": sessionStorage.getItem('userLogin'),
                "imptos": movCliI
              };
              actCargoFra.push(argsUpd)
            }
          })

//APLICAR OFERTA A LOS CARGOS DEL CLIENTE
// let ii = listServOfAct.length + 1
// console.log(listServOfAct)

          const elemCF = actCargoFra.map((elemento2, _id) => elemento2);
          elemCF.forEach((elemento2, ii) => {
            listServOfAct.forEach((elemento1, i) => {
              // if(elemento.codigoServicio===elemento1.codigoServicio&&elemento.valorServicios>0){
              if(elemento2.codigoServicio===elemento1.codigoServicio){
                // console.log(elemento.codigoServicio)
                let valorDcto = 0
                let valorDctoAI = 0
                if(numDF===elemento1.numdiApliOf){
                  valorDcto = elemento2.valorTotal - (elemento2.valorTotal * elemento1.porcDctoOferta / 100)
                  valorDctoAI = elemento2.valorAntesImptos - (elemento2.valorAntesImptos * elemento1.porcDctoOferta / 100)
                }else{
                  valorDcto = (elemento2.valorTotal - (elemento2.valorTotal * elemento1.porcDctoOferta / 100)) / numDF
                  valorDcto = valorDcto * elemento1.numdiApliOf
                  valorDctoAI = (elemento2.valorAntesImptos - (elemento2.valorAntesImptos * elemento1.porcDctoOferta / 100)) / numDF
                  valorDctoAI = valorDctoAI * elemento1.numdiApliOf
                }
                const indexLis = actCargoFra.findIndex(codServ => codServ.codigoServicio === elemento2.codigoServicio);
                valorDcto = parseInt(valorDcto, 10)
                valorDctoAI = parseInt(valorDctoAI, 10)
                if(valorDcto!==0){
                  saldoCl += valorDcto - valorServ
                  actCargoFra[indexLis].valorTotal = valorDcto
                  actCargoFra[indexLis].valorAntesImptos = valorDctoAI
                  actCargoFra[indexLis].saldoCliente = saldoCl

//Actualizar imptos con la oferta
                  actCargoFra[indexLis].imptos.forEach((elemento2, i) => {
                    elemento2.valorImpto = Math.round(valorDctoAI * elemento2.porcImpto / 100)
                  })
                }else{
                  if(indexLis!==-1){
          //pongo comentario porque no veo para que se elimina del array => ????
          // actCargoFra.splice(indexLis, 1);
                  }
                }
              }
            })
            actCargoFra.forEach((elementoDX, ii) => {
              if(this.props.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
                movCliRX.push(elementoDX)
              }else{
                movCli.push(elementoDX)
              }
            })
          })
          if(this.props.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
            saldoCl = saldoClCC
          }
    // console.log(saldoCl)
    
//actualizar saldoCliente y pasar a DX si se DX todos los servicios
          let estCl = clientesDX[indexCargoDX].estadoCliente
          let servDXHC = "No DX todos los servicios"
          if(contServCli===contServDX){
            // console.log("cambiar estado")
            servDXHC = "DX todos los servicios"
            estCl = "DESCONECTADO"

            actFechas.push(argsUpdDX)
          }
          argsUpd = {}
          argsUpd = {
            "tipoAct": "EditarCliOdeS",
            "_id": clientesDX[indexCargoDX]._id,
            "estadoCliente": estCl,
            "cargoMensual": clientesDX[indexCargoDX].cargoMensual,
            "saldoPendiente": saldoCl,
          }
          actCliSaldo.push(argsUpd)
//FIN PROCESO CREAR DOCUM EN MOVIMCLIENTE DE DESCUENTO (SI YA SE FACT) O CARGUE (SI NO SE HA FACT) POR DX
// console.log(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 8))
//CREA REGISTRO EN HISTCLIENTES
          let relacion = this.props.idLista.numeroOdeDX
          let argsAddHC = {
            "fechaHistCliente": fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 8),
            "contrato": elemento.contrato,
            "movimiento": "DX masiva",
            "descripcion": servDXHC,
            "detalle": `Queda en estado ${estCl}`,
            "relacion": relacion.toString(),
            "usuarioCreate": sessionStorage.getItem('userLogin'),
          }
          creaHC.push(argsAddHC)

          argsUpd = {}
          argsUpd = {
            "_id": elemento._id,
            "estadoDetDX": "DX",
          }
          actdetDX.push(argsUpd)

          let indexSearch = actCli.findIndex( cliente => cliente.contrato===elemento.contrato )
          if(indexSearch===-1){
            argsUpd = {}
            argsUpd = {
              "tipoAct": "EditarCliDX",
              "contrato": elemento.contrato,
              "numeroOdeDX": this.props.idLista.numeroOdeDX,
            }
            actCli.push(argsUpd)
          }

          indexSearch = actmovCli.findIndex( movim => movim._id===elemento.idMovim )
          if(indexSearch===-1){
//Lista de los _id de los movim para actualizar numeroOdeDX en movClientes
            argsUpd = {}
            argsUpd = {
              "_id": elemento.idMovim,
              "numeroOdeDX": this.props.idLista.numeroOdeDX,
            }
            actmovCli.push(argsUpd)
          }
        }
      // }
      })

      clientesDX = []
      argsBuscarCL={}
      // argsBuscarCL.numDocum = 1
      argsBuscarCL.contrato = "XYZ321"
      if(this.props.allClientes.allClientes){
        let {data} = await this.props.allClientes.refetch(argsBuscarCL)
        clientesDX = await data.allClientes
      }

      movimDX = []
      argsBuscarMC = {agno: "2017", mes: "03"}
      if(this.props.allMovClientes.allMovClientes){
        let {data} = await this.props.allMovClientes.refetch(argsBuscarMC)
        movimDX = await data.allMovClientes
      }

// console.log(actServCli)
// console.log(actCli)
// console.log(actmovCli)
// console.log(actdetDX)
// console.log(actCliSaldo)
// console.log(movCli)

//Crear detalleDX
//Actualizar numeroOdeDX en movclientes y en clientes
//Actualizar estadoServicio en los servicios de la tarifa del cliente que se DX
//Crea movcliente con fracción de mes a cobrar o descontar (si ya fue facturado)
      let actmovCliMany = [], actCliMany = [], actServCliMany = [], actdetDXMany =[]
      let movCliMany = [], movCliRXMany = []
      let actCliSaldoMany = [], actFechasMany = []
// console.log(movCli)
      movCli.forEach((elementoDX, ii) => {
        movCliMany.push(elementoDX)
      })
// console.log(movCliRX)
      movCliRX.forEach((elementoDX, ii) => {
        movCliRXMany.push(elementoDX)
      })
      actmovCli.forEach((elementoDX, ii) => {
        actmovCliMany.push(elementoDX)
      })
      actCliSaldo.forEach((elementoDX, ii) => {
        actCliSaldoMany.push(elementoDX)
      })
      actFechas.forEach((elementoDX, ii) => {
        actFechasMany.push(elementoDX)
      })
      actCli.forEach((elementoDX, ii) => {
        actCliMany.push(elementoDX)
      })
      actServCli.forEach((elementoDX, ii) => {
        actServCliMany.push(elementoDX)
      })
      actdetDX.forEach((elementoDX, ii) => {
        actdetDXMany.push(elementoDX)
      })

// console.log(actmovCliMany)
// console.log(actCliMany)
// console.log(actCliSaldoMany)
// console.log(actServCliMany)

      let movCliMany1 = [], movCliRXMany1 = []
      if(this.props.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
        movCliRXMany1.push({movcliente: movCliRXMany})
      }else{
        movCliMany1.push({movcliente: movCliMany})
      }
      let actmovCliMany1 = []
      actmovCliMany1.push({movcliente: actmovCliMany})

      let actCliSaldoMany1 = []
      actCliSaldoMany1.push({cliente: actCliSaldoMany})

      let actFechasMany1 = []
      actFechasMany1.push({cliente: actFechasMany})

      let actCliMany1 = []
      actCliMany1.push({cliente: actCliMany})

      let actServCliMany1 = []
      actServCliMany1.push({cliente: actServCliMany})

      let actdetDXMany1 = []
      actdetDXMany1.push({detalledx: actdetDXMany})

//Crear el registro en histclientes
    let creaHCMany = [], creaHCMany1 = []
    creaHC.forEach((elementoHC, ii) => {
      creaHCMany.push(elementoHC)
    })
    creaHCMany1.push({histcliente: creaHCMany})
// console.log(movCliMany1)
// console.log(creaFraMany1)
// console.log(actmovCliMany1)
// console.log(actCliMany1)
// console.log(actCliSaldoMany1)
// console.log(actServCliMany1)

      let numDocCRUD = 0
      let totDocCRUD = 8
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(this.props.editMovClientesDXMany)
      }

      argsCrud[numDocCRUD] = actCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editClienteMany

      numDocCRUD += 1

      argsCrud[numDocCRUD] = actCliSaldoMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editClienteMany

      numDocCRUD += 1

      argsCrud[numDocCRUD] = actFechasMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editClienteMany

      numDocCRUD += 1

      if(this.props.comoAsigCargosAlCliente!=="Hacer los cargos al cliente al cerrar las Ordenes de Servicio"){
        argsCrud[numDocCRUD] = movCliRXMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createMovCliCCMany
      }else{
        argsCrud[numDocCRUD] = movCliMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createMovClientesMany
      }
      numDocCRUD += 1
    
      argsCrud[numDocCRUD] = actServCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editClienteUpdDocMany

      numDocCRUD += 1

      argsCrud[numDocCRUD] = actdetDXMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editDetalleDXMany

      numDocCRUD += 1
      
      argsCrud[numDocCRUD] = creaHCMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.createHistClienteMany

      numDocCRUD += 1

      argsCrud[numDocCRUD] = actmovCliMany1[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = this.props.editMovClientesDXMany

// console.log(argsCrud)
// console.log(totDocCRUD)
      await updColecc(crudColecc, argsCrud, totDocCRUD)

      await this.props.allDetalleDX.refetch(this.props.argsBuscar)
      document.body.style.cursor = 'default'
    }
//FIN PROCESO DX SERVICIOS DX MASIVA

// console.log("Listoooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  handleImprimirTablaXls = (ev, idLista) => {
    var tableToExcel = (function() {
      var nombreArch = 'dxmasiva-' + idLista.numeroOdeDX + '.xls'

      var tmpElemento = document.createElement('a')
//window.btoa => Encode a string in base-64
      var uri = 'data:application/vnd.ms-excel;base64,'
        , template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
                            xmlns:x="urn:schemas-microsoft-com:office:excel">
                        <head>
                          <!--[if gte mso 9]>
                            <xml><x:ExcelWorkbook>
                                  <x:ExcelWorksheets>
                                    <x:ExcelWorksheet>
                                      <x:Name>{worksheet}</x:Name>
                                      <x:WorksheetOptions><x:DisplayGridlines/>
                                      </x:WorksheetOptions>
                                    </x:ExcelWorksheet>
                                  </x:ExcelWorksheets>
                                </x:ExcelWorkbook>
                            </xml>
                          <![endif]-->
                        </head>
                        <body><table>{table}</table></body>
                      </html>`
        , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
      return function(table, hoja) {
        if (!table.nodeType) table = document.getElementById(table)
        var ctx = {worksheet: hoja || 'Worksheet', table: table.innerHTML}
        tmpElemento.href = uri + base64(format(template, ctx))
        tmpElemento.download = nombreArch;
        tmpElemento.click();
      }
    })()

    tableToExcel('tablaDX', 'dxmasiva')
  }

  handleImprimirTablaPdf = (ev) => {
    var doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
    doc.setFontSize(14);
    doc.setFontType("bold");
    let texto1 = this.props.empresa.empresaRazonSocial
    let texto2 = "DX MASIVA No. " + this.props.idLista.numeroOdeDX
    let texto3 = `Movimientos con mora mayor o igual a ${this.props.idLista.diasMora} días`
    let texto4 = `Movimientos con saldo pendiente por pagar mayor o igual a ${this.props.idLista.porcMovim} % del valor del movimiento`
    let texto5 = `Movimientos con saldo pendiente por pagar mayor o igual a $ ${this.props.idLista.valorMovim}`
    let texto6 = `En los últimos ${this.props.idLista.diasDXDesde} días se DX ${this.props.idLista.numVecesDX} o más veces`
    // let texto6= `DX: ${this.props.idLista.servaDX}`
    let texto7 = `DEPARTAMENTO: ${this.props.idLista.descrDpto} => CIUDAD: ${this.props.idLista.nombreCiudad}`
    let texto8 = `ZONA: ${this.props.idLista.nombreZona} => BARRIO: ${this.props.idLista.nombreBarrio}`
    let texto9 = `CLASE: ${this.props.idLista.descrClaseServ}`

    doc.text(texto1, 108, 20, 'center')
    doc.setFontSize(12);
    doc.text(texto2, 108, 30, 'center')
    doc.setFontSize(10);
    doc.text(texto3, 108, 40, 'center')
    doc.text(texto4, 108, 47, 'center')
    doc.text(texto5, 108, 54, 'center')
    doc.text(texto6, 108, 61, 'center')
    doc.text(texto7, 108, 68, 'center')
    doc.text(texto8, 108, 75, 'center')
    doc.text(texto9, 108, 82, 'center')

    var source = document.getElementById("tablaDX");
    doc.autoTable({startY: 95,
                    tableLineColor: "blue",
                    tableLineWidth: 0.1,
                    styles: {
                      // font: 'Calibri',
                      fontSize: 10,
                      lineColor: "black",
                      lineWidth: 0.1
                    },
                    headStyles: {
                      fillColor: "#bdc3c7",
                      textColor: "black",
                      fontSize: 12
                    },
                    bodyStyles: {
                      fillColor: "#E9E4F0",
                      textColor: "black"
                    },
                    alternateRowStyles: {
                      fillColor: "white",
                      textColor: "black"
                    },
                    html: source,
                    margin: {top: 10, left: 2, right: 2},})
    // let finalY = doc.previousAutoTable.finalY; //para traer posicion final de la tabla
    // doc.text("TOTAL", 50, finalY + 15);
    doc.autoPrint({variant: 'non-conform'});
    // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
    // => UTILIZAR
    const pdfBlob = doc.output('blob');
    const url = URL.createObjectURL(pdfBlob);
    window.open(url);
    // doc.save('dxmasiva-' + this.props.idLista.numeroOdeDX + '.pdf')
  }

  componentDidUpdate(prevProps){
    if(this.props!==prevProps){
      // console.log("refetch")
      let argsBuscar = {numeroOdeDX: this.props.idLista.numeroOdeDX, ...this.props.argsBuscar}
      this.props.allDetalleDX.refetch(argsBuscar)
    }
    // if(this.props.argsBuscar!==prevProps.argsBuscar){
    //   let argsBuscar = {numeroOdeDX: this.props.idLista.numeroOdeDX, ...this.props.argsBuscar}
    //   // console.log(argsBuscar)
    //   this.props.allDetalleDX.refetch(argsBuscar)
    // }
  }

  render(){
    const {confirmaAct, open, errors} = this.state;
    const a101015 = this.props.autorizacUA.findIndex( autorizac => autorizac === "101015" );
    const a101020 = this.props.autorizacUA.findIndex( autorizac => autorizac === "101020" );

    let creaDetDX = []
    let totCli = 0
    if(this.props.allDetalleDX.allDetalleDX){
      creaDetDX = this.props.allDetalleDX.allDetalleDX

      let listCli = []
      creaDetDX.forEach(async (elemento, _id) => {
        const indexSearchCl = listCli.findIndex( cliente => cliente.contrato===elemento.contrato )
        if(indexSearchCl===-1){
          listCli.push({contrato: elemento.contrato})
        }
      })
      totCli = listCli.length
    }

//     console.log(this.props.allDetalleDX.allDetalleDX)
// console.log(this.props.argsBuscar)
// console.log(creaDetDX)
// console.log(this.props.allClientes.allClientes)
// console.log(this.props.allMovClientes.allMovClientes)
    let mensajeUpd = "HACER LA DX DE LOS SERVICIOS A LOS CLIENTES"
    let mensajeDel = "ELIMINAR LOS SERVICIOS DE LA LISTA DE SERVICIOS A DX"
    let mensajeClo = "CERRAR DX MASIVA No. " + this.props.idLista.numeroOdeDX

    let titulo = "DX masiva No. " + this.props.idLista.numeroOdeDX +  " => " + this.props.idLista.estadoProcDX
// console.log(this.props.permiteUpdate)
// console.log(this.props.permiteDelete)
// console.log(this.props.permiteClose)

    let mensajeOpc1 = ""
    let mensajeOpc2 = ""
    if(this.props.permiteUpdate){
      mensajeOpc1 = `=>`
      mensajeOpc2 = `DX: ${totCli}    Servicios: ${creaDetDX.length}`
    }
    if(this.props.permiteDelete){
      mensajeOpc1 = `=>  `
      mensajeOpc2 = `ELIMINAR: ${totCli}    Servicios: ${creaDetDX.length}`
    }

// let imgIcon = "images/archivo_32.png"

// console.log(this.props.list)
// console.log(this.props.idLista)
    return(
      <div>
          <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
              <i className="large plus yellow icon"></i>
              DX masiva
          </button>
          <div>
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                      <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, creaDetDX):()=>{}}>
                        <div>
                            <div className="ui two column stackable grid">
                                <div className="row container">
                                    <div className="column" style={{width: '55%'}}>
                                      <h1 style={{color: '#2C7744'}}>{titulo}</h1>
                                      <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0em'}}>
                                          Clientes y servicios a DX. Los días en mora<br/>
                                          se calculan asi: Fecha de referencia - Fecha límite de pago
                                      </p>
                                    </div>
                                    <div className="column" style={{width: '45%'}}>
                                      <p>
                                        <span style={{background: '#7F7FD5', padding: '0.5em', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                                          Fecha de referencia: &nbsp;&nbsp;
                                          <span>
                                            <input value={this.props.idLista.fechaRef.substr(0, 10)} style={{color: '#302b63', fontSize: '2em', padding: '0.5em'}} type='date' name="fechaRef" id="fechaRef" onChange={this.handleChange}/>
                                          </span>
                                        </span>
                                      </p>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <Form.Field>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                Movimientos con mora mayor o igual a {this.props.idLista.diasMora} días
                              </label>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                Movimientos con saldo pendiente por pagar mayor o igual a {this.props.idLista.porcMovim} % del valor del movimiento
                              </label>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                Movimientos con saldo pendiente por pagar mayor o igual a $ {this.props.idLista.valorMovim}
                              </label>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                En los últimos {this.props.idLista.diasDXDesde} días se DX {this.props.idLista.numVecesDX} o más veces
                              </label>
                              {/* <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                DX: {this.props.idLista.servaDX}
                              </label> */}
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                DEPARTAMENTO: {this.props.idLista.descrDpto} ={'>'} CIUDAD: {this.props.idLista.nombreCiudad}
                              </label>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                ZONA: {this.props.idLista.nombreZona} ={'>'} BARRIO: {this.props.idLista.nombreBarrio}
                              </label>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                CLASE: {this.props.idLista.descrClaseServ}
                              </label>
                            </Form.Field>
                            <hr></hr>

                            <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Totales DX Masiva generada:  Clientes:&nbsp;
                              {this.props.idLista.totCliDX}&nbsp;&nbsp;&nbsp;&nbsp;
                              Servicios:&nbsp;
                              {this.props.idLista.totServDX}  {mensajeOpc1}  <b style={{color: '#93291E'}}>{mensajeOpc2}</b>
                            </p>
                            <p>&nbsp;&nbsp;&nbsp;
                              {a101015!==-1 &&
                                <button className="ui right labeled icon button" style={this.props.styles.styBtn} onClick={(ev)=>this.handleImprimirTablaXls(ev, this.props.idLista)}>
                                  <i className='file excel outline icon'></i>
                                  Excel
                                </button>
                                // <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTablaXls(ev, this.props.idLista)}><i className='file excel outline icon'></i>Excel</a>
                              }
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              {a101020!==-1 &&
                                <button className="ui right labeled icon button" style={this.props.styles.styBtn} onClick={(ev)=>this.handleImprimirTablaPdf(ev)}>
                                  <i className='file pdf outline icon'></i>
                                  Pdf
                                </button>
                              // <a className='ui large label' style={this.props.styles.styTableInf} onClick={(ev)=>this.handleImprimirTablaPdf(ev)}><i className='file pdf outline icon'></i>Pdf</a>
                              }
                            </p>

                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '100%'}}>
                                  <EstaSeguro permiteUpdate={this.props.permiteUpdate}
                                    permiteDelete={this.props.permiteDelete} permiteClose={this.props.permiteClose}
                                    open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}
                                    msgUpd={mensajeUpd} msgDel={mensajeDel} msgClo={mensajeClo}/>

<hr></hr>
                        
{
                          errors.length?<Message negative header="Los siguientes errores:"
                          list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                      }

                                </div>
                              </div>
                            </div>
                            <hr></hr>
                            <table id="tablaDX" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                              <thead className=''>
                                <tr className=''>
                                  <th rowSpan='2' className=''>Estado</th>
                                  <th rowSpan='2' className=''>Contrato</th>
                                  <th colSpan='2' className='center aligned'>Servicio a DX</th>
                                  <th colSpan='7' className='center aligned'>Servicio en mora</th>
                                  <th rowSpan='2' className=''># DX</th>
                                </tr>
                                <tr className=''>
                                  <th className=''>Clase</th>
                                  <th className=''>Servicio</th>
                                  <th className=''>Clase</th>
                                  <th className=''>Servicio</th>
                                  <th className=''>Documento</th>
                                  <th className='right aligned'>$ Total</th>
                                  <th className='right aligned'>$ Pagado</th>
                                  <th className=''>Pague hasta</th>
                                  <th className=''>Mora</th>
                                </tr>
                              </thead>
                              <ListaDX list={creaDetDX}/>
                            </table>
                        </div>

                      </Form>
                    </div>
                </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: argsBuscarCL}}}),
  // graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: argsBuscarMC}}}),
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {estadoCliente: "ACTIVO", numDocum: 1}}}}),
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {contrato: "XYZ321"}}}}),

  graphql(queries.query.allClientesRtes, {name:'allClientesRtes', options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: "XYZ321"}}]`}}}}),

  graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {agno: "2017", mes: "03"}}}}),

  graphql(queries.query.allMovClientesCC, {name:'allMovClientesCC', options: (props) => {return {variables: {agno: "2017", mes: "03"}}}}),

  graphql(queries.query.allDetalleDX, {name:'allDetalleDX', options: (props) => {return {variables: {numeroOdeDX: props.idLista.numeroOdeDX, ...props.argsBuscar}}}}),
  graphql(queries.mutation.deleteDetalleDXMany, {name:'deleteDetalleDXMany'}),

  graphql(queries.mutation.editClienteUpdDocMany, {name:'editClienteUpdDocMany'}),
  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
  graphql(queries.mutation.editMovClientesDXMany, {name:'editMovClientesDXMany'}),
  graphql(queries.mutation.editDetalleDXMany, {name:'editDetalleDXMany'}),
  graphql(queries.mutation.createMovClientesMany, {name:'createMovClientesMany'}),
  graphql(queries.mutation.createMovCliCCMany, {name:'createMovCliCCMany'}),

  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),

  graphql(queries.mutation.editProcDX, {name:'editProcDX'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
  )(VerCliDX2)
